"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WaitInputProcessing {
    constructor(skills) {
        this.skills = skills;
        this.selection = null;
    }
}
exports.WaitInputProcessing = WaitInputProcessing;
function waitInputProcessor(battle, data, step) {
    switch (step) {
        case 1: {
            if (data.selection)
                return -1;
            return 1;
        }
    }
    return;
}
exports.default = waitInputProcessor;
